import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, message, Checkbox } from 'antd'
import { useDispatch } from 'react-redux'
import {
  // loadingActions,
  loadingActionsTip
} from '@/redux/actions/loadingActions'
import moment from 'moment'
import { modalError } from '@/utils/modalUtils'
import { getOrderSearch, getOrderExport, uploadBatchQueryExcel, getConfigQuery } from '@/services/orderQuery/byBatch'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import {
  // paginationInit,
  formatMessage,
  downloadTemplate,
  uniqueFun2,
  uniqueFun,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  dateFormatYearMonthDay2
} from '@/utils/common'
import { YES_NO_STATUS, RETURN_STATUS } from '@/utils/types'
import UploadBtn from '@/components/Upload/Upload'
// import * as XLSX from 'xlsx'
const ByBatchPage = props => {
  const dispatch = useDispatch()
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  let searchListInit = [
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.store',
      key: 'store',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      // maxTagTextLength: 10,
      showAll: true,
      selectList: []
    },
    {
      type: 'timeRange',
      label: 'languageObj.byBatchLocale.salesOrderDate',
      key: 'salesOrderDate',
      showRangePresets: true,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: []
    },
    {
      type: 'timeRange',
      label: 'languageObj.byBatchLocale.returnRequestDate',
      key: 'returnRequestDate',
      showRangePresets: true,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: []
    },
    {
      type: 'timeRange',
      label: 'languageObj.byBatchLocale.returnCreateDate',
      key: 'returnCreateDate',
      showRangePresets: true,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: []
    },
    {
      type: 'timeRange',
      label: 'languageObj.byBatchLocale.rwReceiveDate',
      key: 'rwReceiveDate',
      showRangePresets: true,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: []
    },
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.returnStatus',
      key: 'returnStatus',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: RETURN_STATUS
    },
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.refundStatus',
      key: 'refundStatus',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: YES_NO_STATUS
    },
    {
      type: 'input',
      label: 'languageObj.byBatchLocale.upc',
      key: 'sku',
      initialValues: ''
    },
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.dlpOrderRiskWarning',
      key: 'dlpAlertType',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    },
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.dlpUserLevel',
      key: 'dlpAccountLevel',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    },
    {
      type: 'textArea',
      label: 'languageObj.receiptData.omsReturnCode',
      key: 'omsReturnCode',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.commonLocale.placeholderFormat')
    },
    {
      type: 'textArea',
      label: 'languageObj.byBatchLocale.salesOrderNumber',
      key: 'platformOrderNo',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.commonLocale.placeholderFormat')
    },
    {
      type: 'textArea',
      label: 'languageObj.byBatchLocale.returnOrderNumber',
      key: 'platformReturnNo',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.commonLocale.placeholderFormat')
    },
    {
      type: 'textArea',
      label: 'languageObj.byBatchLocale.returnTrackingNumber',
      key: 'returnTrackingNo',
      autoSize: { minRows: 3, maxRows: 3 },
      initialValues: '',
      placeholder: formatMessage('languageObj.commonLocale.placeholderFormat')
    },
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.warningType',
      key: 'alertType',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      showAll: true,
      selectList: []
    }
  ]

  const [searchList, setSearchList] = useState(searchListInit)
  const [checkboxVal, setCheckboxVal] = useState(false)
  // 查询标志
  const [queryFlag, setQueryFlag] = useState(false)
  // const [pagination, setPagination] = useState(paginationInit)
  const tableColumns = [
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol1'),
      dataIndex: 'ro_platform_ra_code',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol2'),
      dataIndex: 'ro_tracking_no',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol3'),
      dataIndex: 'ro_platform_apply_time',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol4'),
      dataIndex: 'ro_return_flag_text',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.interceptedText'),
      dataIndex: 'ep_is_intercepted_text',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol5'),
      dataIndex: 'ro_status_text',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol6'),
      dataIndex: 'ep_route_status_text',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol7'),
      dataIndex: 'so_shop_name',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol8'),
      dataIndex: 'so_platform_order_code',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.byBatchLocale.tableCol10'),
      dataIndex: 'ro_is_refunded_text',
      width: 70,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    // 获取店铺
    getConfigQueryFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchDataBtn = () => {
    // const pg = {
    //   ...pagination,
    //   currentPage: 1
    // }
    // setPagination(pg)
    mounting.current = true
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    // const pg = {
    //   ...pagination,
    //   currentPage: 1
    // }
    // setPagination(pg)
    // setQueryFlag(!queryFlag)
  }
  // 获取下拉框数据
  const getConfigQueryFun = () => {
    Promise.all([
      getConfigQuery({ configType: 'nike_shop_code' }),
      getConfigQuery({ configType: 'dlp_alert_type' }),
      getConfigQuery({ configType: 'dlp_account_level' }),
      getConfigQuery({ configType: 'alert_name_config' })
    ]).then(res => {
      try {
        searchListInit.forEach(itemFirst => {
          if (
            itemFirst.key === 'store' ||
            itemFirst.key === 'dlpAlertType' ||
            itemFirst.key === 'dlpAccountLevel' ||
            itemFirst.key === 'alertType'
          ) {
            let uniqueRes = []
            switch (itemFirst.key) {
              case 'store':
                let data0 = res[0].resultData || []
                uniqueRes = formatOptions(data0)
                break
              case 'dlpAlertType':
                let data1 = res[1].resultData || []
                uniqueRes = formatOptions(data1)
                break
              case 'dlpAccountLevel':
                let data2 = res[2].resultData || []
                uniqueRes = formatOptions(data2)
                break
              case 'alertType':
                let data3 = res[3].resultData || []
                uniqueRes = formatOptions(data3)
                break
              default:
                uniqueRes = []
                break
            }
            let unique = uniqueFun(uniqueRes)
            itemFirst.selectList = unique
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {
        console.log(error)
      }
    })
  }
  const formatOptions = ls => {
    let resLs = []
    for (let index = 0; index < ls.length; index++) {
      const element = ls[index]
      resLs.push({
        label: element.configValue,
        value: element.configKey
      })
    }
    return resLs
  }
  const getSearchInfo = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}

    let omsReturnCode = info.omsReturnCode ? info.omsReturnCode.split('\n').filter(Boolean) : []
    let platformOrderNo = info.platformOrderNo ? info.platformOrderNo.split('\n').filter(Boolean) : []
    let platformReturnNo = info.platformReturnNo ? info.platformReturnNo.split('\n').filter(Boolean) : []
    let returnTrackingNo = info.returnTrackingNo ? info.returnTrackingNo.split('\n').filter(Boolean) : []
    let { salesOrderDate, returnRequestDate, returnCreateDate, rwReceiveDate } = info
    let salesOrderDateStart = formatStartTime(salesOrderDate, 2, dateFormatYearMonthDay2)
    let salesOrderDateEnd = formatEndTime(salesOrderDate, 2, dateFormatYearMonthDay2)
    let returnRequestDateStart = formatStartTime(returnRequestDate, 2, dateFormatYearMonthDay2)
    let returnRequestDateEnd = formatEndTime(returnRequestDate, 2, dateFormatYearMonthDay2)
    let returnCreateDateStart = formatStartTime(returnCreateDate, 2, dateFormatYearMonthDay2)
    let returnCreateDateEnd = formatEndTime(returnCreateDate, 2, dateFormatYearMonthDay2)
    let rwReceiveDateStart = formatStartTime(rwReceiveDate, 2, dateFormatYearMonthDay2)
    let rwReceiveDateEnd = formatEndTime(rwReceiveDate, 2, dateFormatYearMonthDay2)
    let store = info.store.join(',')
    let returnStatus = info.returnStatus.join(',')
    let refundStatus = info.refundStatus.join(',')
    let dlpAlertType = info.dlpAlertType.join(',')
    let dlpAccountLevel = info.dlpAccountLevel.join(',')
    let alertType = info.alertType.join(',')
    const params = {
      ...info,
      store,
      returnStatus,
      refundStatus,
      omsReturnCode: omsReturnCode.join(','),
      platformOrderNo: platformOrderNo.join(','),
      platformReturnNo: platformReturnNo.join(','),
      returnTrackingNo: returnTrackingNo.join(','),
      salesOrderDate: salesOrderDateStart,
      salesOrderDateEnd: salesOrderDateEnd,
      returnRequestDate: returnRequestDateStart,
      returnRequestDateEnd: returnRequestDateEnd,
      returnCreateDate: returnCreateDateStart,
      returnCreateDateEnd: returnCreateDateEnd,
      rwReceiveDate: rwReceiveDateStart,
      rwReceiveDateEnd: rwReceiveDateEnd,
      dlpAlertType,
      dlpAccountLevel,
      alertType
    }
    if (checkboxVal) {
      params.abnormalPackageFlag = true
    }
    return params
  }
  const searchDataFun = () => {
    let info = getSearchInfo()
    const params = {
      ...info
      // size: pagination.pageSize,
      // pageNo: pagination.currentPage
    }
    getOrderSearch(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      // const pg = {
      //   ...pagination,
      //   total: dt.total
      // }
      // setPagination(pg)
    })
  }
  // 分页查询
  // const handleTableChange = pagina => {
  //   const params = {
  //     ...pagination,
  //     currentPage: pagina.current,
  //     pageSize: pagina.pageSize
  //   }
  //   setPagination({ ...params })
  //   setQueryFlag(!queryFlag)
  // }
  // 导出结果
  const downLoadFun = () => {
    let info = getSearchInfo()
    const params = {
      ...info
    }
    getOrderExport(params).then(res => {
      message.success(formatMessage('languageObj.byBatchLocale.downloadTip'))
    })
  }
  // 下载模板
  const downLoadTemplateFun = () => {
    downloadTemplate('/CRO Query Template.xlsx')
  }
  const onCheckboxChange = e => {
    setCheckboxVal(e.target.checked)
  }
  // 上传查询条件
  const uploadFun = fileInfo => {
    dispatch(loadingActionsTip(formatMessage('languageObj.byBatchLocale.loadingTip')))
    uploadBatchQueryExcel(fileInfo)
      .then(res => {
        let data = (res && res.resultData) || {}
        let fileObjs = {}
        fileObjs.platformOrderNo = uniqueFun2(data.platformOrderNo || []).join('\n')
        fileObjs.platformReturnNo = uniqueFun2(data.platformReturnNo || []).join('\n')
        fileObjs.returnTrackingNo = uniqueFun2(data.returnTrackingNo || []).join('\n')
        formRef && formRef.current.setValue(fileObjs)
        message.success(formatMessage('languageObj.commonLocale.success'))
        dispatch(loadingActionsTip(''))
      })
      .catch(err => {
        dispatch(loadingActionsTip(''))
        if (err.errorcode === '5001') {
          modalError({
            content: formatMessage('languageObj.byBatchLocale.maxErrorTitle')
          })
        } else {
          modalError({
            content: formatMessage('languageObj.httpLocale.requestError')
          })
        }
      })
    // // 前端解析xlsx
    // console.time('upload')
    // dispatch(loadingActions(true))
    // dispatch(loadingActionsTip(formatMessage('languageObj.byBatchLocale.loadingTip')))
    // const file = fileInfo.get('file')
    // const reader = new FileReader()
    // reader.onload = e => {
    //   const arrayBuffer = e.target.result
    //   const workbook = XLSX.read(arrayBuffer, { type: 'array' })
    //   const firstSheetName = workbook.SheetNames[0]
    //   const worksheet = workbook.Sheets[firstSheetName]
    //   const jsonData = XLSX.utils.sheet_to_json(worksheet) || []
    //   if (jsonData && jsonData.length > 20) {
    //     modalError({
    //       content: formatMessage('languageObj.byBatchLocale.maxErrorTitle')
    //     })
    //     return
    //   }
    //   let fileObjs = {}
    //   let fileValues1 = []
    //   let fileValues2 = []
    //   let fileValues3 = []

    //   for (let index = 0; index < jsonData.length; index++) {
    //     const element = jsonData[index]
    //     if (element['平台订单编码']) {
    //       fileValues1.push(element['平台订单编码'])
    //     }
    //     if (element['平台退货编号']) {
    //       fileValues2.push(element['平台退货编号'])
    //     }
    //     if (element['退货快递单号']) {
    //       fileValues3.push(element['退货快递单号'])
    //     }
    //   }

    //   fileObjs.platformOrderNo = uniqueFun2(fileValues1 || []).join('\n')
    //   fileObjs.platformReturnNo = uniqueFun2(fileValues2 || []).join('\n')
    //   fileObjs.returnTrackingNo = uniqueFun2(fileValues3 || []).join('\n')
    //   formRef && formRef.current.setValue(fileObjs)
    //   message.success(formatMessage('languageObj.commonLocale.success'))
    //   console.timeEnd('upload')
    // }
    // reader.readAsArrayBuffer(file)
    // dispatch(loadingActions(false))
    // dispatch(loadingActionsTip(''))
  }
  return (
    <div>
      <Card>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchList}></SearchBar>
          <div className="mt10">
            <div className="right_search">
              <UploadBtn
                uploadAjax={file => uploadFun(file)}
                btnName={formatMessage('languageObj.byBatchLocale.uploadQueryData')}
                buttonType="default"
              />
              <Button onClick={downLoadTemplateFun}>
                {formatMessage('languageObj.byBatchLocale.downloadQueryTemplate')}
              </Button>
              <Button type="primary" onClick={searchDataBtn}>
                {formatMessage('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessage('languageObj.commonLocale.clear')}</Button>
              <Button type="primary" onClick={downLoadFun}>
                {formatMessage('languageObj.byBatchLocale.exportResults')}
              </Button>
              <Checkbox className="ml10 defaultColor" checked={checkboxVal} onChange={onCheckboxChange}>
                {formatMessage('languageObj.byBatchLocale.downloadCheckBox')}
              </Checkbox>
            </div>
          </div>
        </div>
      </Card>

      <Card className="mt15">
        <div className="content-container">
          <div>
            <AntdTable
              title={() => (
                <div>
                  <div className="defaultColor">{formatMessage('languageObj.byBatchLocale.tableTitle')}</div>
                </div>
              )}
              dataSource={tableList}
              columns={tableColumns}
              // pagination={pagination}
              pagination={false}
              // onChange={handleTableChange}
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
export default ByBatchPage
